import { isMasked } from "./maskedValue";

export function formatCurrency(rawVal) {
  if (isMasked(rawVal)) return rawVal.trim();
  const val = Number(rawVal) || 0;
  const absVal = Math.abs(val);
  const sign = val < 0 ? "-" : "";

  if (absVal < 100_000) {
    return `${sign}$${absVal.toLocaleString()}`;
  }

  if (absVal < 1_000_000) {
    return `${sign}$${(absVal / 1_000).toFixed(1)}K`;
  }

  return `${sign}$${(absVal / 1_000_000).toFixed(2)}M`;
}